import {useCallback, useState} from "react";

export const useRandomColor = () => {
  const [_,  setColors] = useState<string[]>(['#' + Math.random().toString(16).substr(-6)]);

  const generateColor = useCallback(() => {
    let c1 = '#' + Math.random().toString(16).substr(-6);

    setColors(c => {
      while (c.includes(c1))
        c1 = '#' + Math.random().toString(16).substr(-6);
      return [...c, ...c1]
    });

    return c1;
  }, []);

  return {generateColor};
}
